export const roles = {
    administrator: {
        id: 1,
        name: "Administrator"
    },
    customer: {
        id: 2,
        name: "customer"
    }
}